const getAlignmentValue = (currentImageAsDomElement, ALIGNMENT_OPTIONS) => {
  try {
    const imgEl = currentImageAsDomElement;
    if (imgEl.style.float === 'right') {
      return ALIGNMENT_OPTIONS.right;
    }
    if (imgEl.style.display === 'block') {
      return ALIGNMENT_OPTIONS.center;
    }
    return ALIGNMENT_OPTIONS.left;
  } catch (error) {
    return ALIGNMENT_OPTIONS.left;
  }
};
export default getAlignmentValue;